import { Avatar, Chip, Typography, styled } from '@mui/material';
import { AccountType } from 'further-types/investor';
import { Column, Row } from 'further-ui/components/Layout';
import { pluralize } from 'further-ui/utils';

type Props = {
  name: string;
  accountType: AccountType;
  users: Array<{
    userEmail: string;
  }>;
};

const AccountTypeChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[600],
  padding: theme.spacing(theme.spacingSizes.xxs, theme.spacingSizes.xs),
}));

const InvestorAvatar = styled(Avatar)(({ theme }) => ({
  width: 24,
  height: 24,
  fontSize: theme.fontSizes.sm,
}));

const accountTypes = {
  [AccountType.Individual]: 'Individual',
  [AccountType.LegalEntity]: 'Legal entity',
} as const;

const InvestorSearchResult: React.FC<Props> = ({
  name,
  accountType,
  users,
}) => {
  const userCount = users.length;
  const userText = userCount
    ? `${users[0].userEmail}${
        userCount > 1
          ? ` and ${userCount - 1} ${pluralize('other', userCount - 1)}`
          : ''
      }`
    : '';
  return (
    <Row centered justify="space-between" spacing="xs" fullWidth>
      <Row centered spacing="xs">
        <InvestorAvatar variant="circular">{name.charAt(0)}</InvestorAvatar>
        <Column spacing="xxs">
          <Typography variant="h6">{name}</Typography>
          <Typography variant="caption">{userText}</Typography>
        </Column>
      </Row>
      <AccountTypeChip
        size="small"
        variant="filled"
        label={accountTypes[accountType]}
      />
    </Row>
  );
};

export default InvestorSearchResult;
